export const data = {
	data() {
		return {
			headerList: [
				{
					prop: 'product_title',
					label: '课程标题',
					width: 120
				},
				{
					prop: 'pay_amount',
					label: '支付金额',
					align: 'center',
					width: 120
				},
				{
					prop: 'total_red_discount',
					label: '订单平台优惠金额',
					align: 'center',
					width: 140
				},
				{
					prop: 'status',
					label: '订单状态',
					width: 100
				},
				{
					prop: 'talent_name',
					label: '推广人小红书',
					width: 150
				},
				{
					prop: 'address_user_name',
					label: '购买人',
					width: 130
				},
				{
					prop: 'address_phone',
					label: '购买人手机号',
					width: 130
				},
				{
					prop: 'address',
					label: '购买人地址',
					width: 130
				},
				{
					prop: 'author_income',
					label: '实际收益',
					width: 100,
					// tip: '订单结算后的真实有效收益'
				},
				// {
				// 	prop: 'estimate_income',
				// 	label: '预估收益',
				// 	width: 100,
				// 	tip: '平台系统预估收益，以最终实际结算收益为准'
				// },
				{
					prop: 'income_status_desc',
					label: '收益状态',
					width: 90
				}
			],
			stateList: [ // 筛选状态列表
				{
					label: '全部',
					value: ''
				},
				{
					label: '已购买',
					value: 4,
				},
				{
					label: '已退款',
					value: 7,
				},
				{
					label: '待支付',
					value: 2,
				},
				{
					label: '退款中',
					value: 9,
					class: 'refund'
				},
			],
			stateObj: { // 订单状态(table内的)
				2: {
					label: '待支付',
					class: 'refund'
				},
				4: {
					label: '已购买',
					class: ''
				},
				7: {
					label: '已退款',
					class: 'refund'
				},
				9: {
					label: '退款中',
					class: 'refund'
				},
				10:{
					label: '拒绝退款',
					class: 'refund'
				},
				11: {
					label: '退款申请中',
					class: 'refund'
				},
				12: {
					label: '关闭订单',
					class: 'refund'
				},
			}
		}
	}
}